import React, { useState } from 'react';
import Markdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import cx from 'classnames';

import TypographySwitcher from '../TypographySwitcher';

import { Body2, Subtitle1 } from '../Typography';
import { ReactComponent as ArrowDownIcon } from '../../assets/svg/accordion-down.svg';

import { useMeasureAccordionContentHeight } from '../../app/hooks/useMeasureAccordionContentHeight';

import styles from './index.module.scss';

export enum FontWeight {
  BOLD = 'bold',
  NORMAL = 'normal',
}

export interface TextAccordionProps {
  title: string;
  price?: string;
  text?: string;
  className?: string;
  isOpenByDefault?: boolean;
  fontWeight?: FontWeight;
}

const TextAccordion: React.FC<TextAccordionProps> = ({
  title,
  price,
  text,
  className,
  isOpenByDefault = false,
  fontWeight = FontWeight.NORMAL,
}) => {
  const [isOpen, setIsOpen] = useState(isOpenByDefault);
  const { contentRef, contentHeight } = useMeasureAccordionContentHeight();

  const handleAccordionClick = () => {
    setIsOpen(!isOpen);
  };

  const isFontWeightNormal = fontWeight === FontWeight.NORMAL;

  return (
    <li className={cx(styles.wrapper, className)}>
      <button onClick={handleAccordionClick} className={styles.header}>
        <div className={styles.headerIconAndTitleWrapper}>
          <ArrowDownIcon
            className={cx({
              [styles.arrowDown]: true,
              [styles.arrowUp]: isOpen,
            })}
          />
          {isFontWeightNormal ? (
            <TypographySwitcher
              mobile='body2'
              tablet='body1'
              desktop='body1'
              className={styles.title}
            >
              {title}
            </TypographySwitcher>
          ) : (
            <Subtitle1 className={styles.title}>{title}</Subtitle1>
          )}
        </div>
        {isFontWeightNormal ? (
          <TypographySwitcher
            mobile='body2'
            tablet='body1'
            desktop='body1'
            className={styles.price}
          >
            {price}
          </TypographySwitcher>
        ) : (
          <Subtitle1 element='p' className={styles.price}>
            {price}
          </Subtitle1>
        )}
      </button>

      <div
        ref={contentRef}
        className={styles.contentWrapper}
        style={{ maxHeight: isOpen ? contentHeight : 0 }}
      >
        <div className={styles.content}>
          {text && (
            <Body2 element='div' className={styles.text}>
              <Markdown rehypePlugins={[rehypeRaw]}>{text}</Markdown>
            </Body2>
          )}
        </div>
      </div>
    </li>
  );
};
export default TextAccordion;
